export const SERVICES_EN = [
  {
    title: "Administrative documents",
    short: "Passport, national ID card, police clearance, civil status records, driving licence, visa and more.",
    items: [
      "Togolese passport",
      "National ID card (CNI)",
      "Police clearance certificate",
      "Birth certificates & civil status records",
      "Driving licence",
      "Travel pass (sauf-conduit)",
      "Visa & residence formalities",
      "Other administrative procedures",
    ],
  },
  {
    title: "Company formation",
    short: "From idea to registration: we set up your company in Togo from start to finish.",
    items: [
      "Guidance on legal structure",
      "Application file preparation",
      "Incorporation formalities (CFE)",
      "NIF & RCCM registration",
      "Constitutive documents",
      "Post-incorporation formalities",
      "Support for entrepreneurs & investors",
    ],
  },
  {
    title: "Diaspora services",
    short: "Your procedures in Togo without travelling: we act on your behalf, wherever you are.",
    items: [
      "Procedures handled remotely",
      "Administrative representation in Togo",
      "Real-time case tracking",
      "Real estate projects & land title checks",
      "Legalisation & apostille of documents",
    ],
  },
  {
    title: "Foreign nationals",
    short: "Visit, work, invest or settle in Togo with complete peace of mind.",
    items: [
      "Entry visa & stay extension",
      "Temporary / permanent residence permit",
      "Relocation & mobility formalities",
      "Investment & subsidiary setup",
      "Full administrative support",
    ],
  },
  {
    title: "Business services",
    short: "Administrative assistance, file preparation and follow-up for SMEs and organisations.",
    items: [
      "Day-to-day administrative assistance",
      "File preparation & follow-up",
      "Formalities with government agencies",
      "Support for executives living abroad",
    ],
  },
];

export const STEPS_EN = [
  { title: "Describe your need", desc: "Fill in the form in 2 minutes or write to us on WhatsApp. Simply tell us what you need." },
  { title: "Receive information & terms", desc: "Within 24h, you receive the exact list of required documents, estimated timelines and a clear quote, with no surprises." },
  { title: "Prepare & send your documents", desc: "Send your documents via our secure form or WhatsApp. We check every document for compliance." },
  { title: "DOC TOGO processes & tracks your case", desc: "Our teams file, follow up and track your application with the authorities. You are informed at every step." },
  { title: "Receive your document or result", desc: "Hand delivery, agency pick-up or secure international shipping. Your procedure is completed, wherever you are." },
];

export const VALUES_EN = [
  { title: "Simplicity", desc: "A clear journey, plain language, zero administrative jargon." },
  { title: "Reliability", desc: "Every case is followed through to completion, with evidence." },
  { title: "Transparency", desc: "A detailed quote before any commitment. No hidden fees." },
  { title: "Confidentiality", desc: "Your documents and data are protected and never shared." },
  { title: "Responsiveness", desc: "Reply within 24 business hours, real-time case tracking." },
  { title: "Professionalism", desc: "An experienced team, fully versed in Togolese procedures." },
];

export const TESTIMONIALS_EN = [
  {
    name: "Kossi A.",
    role: "Diaspora — Paris, France",
    text: "I got my passport and police clearance without leaving Paris. Impeccable follow-up, deadlines met. Highly recommended.",
  },
  {
    name: "Aïcha B.",
    role: "Entrepreneur — Lomé, Togo",
    text: "My SARL was incorporated in a few days: RCCM, NIF, articles of association, everything was ready. Professional support from start to finish.",
  },
  {
    name: "Marc D.",
    role: "Investor — Brussels, Belgium",
    text: "To settle and invest in Togo, DOC TOGO handled the visa, residence permit and my subsidiary setup. Efficient and reassuring.",
  },
];

export const FAQ_ITEMS_EN = [
  {
    q: "How can I complete a procedure from abroad?",
    a: "That is our specialty. You describe your need via the form or WhatsApp, send us your documents through our secure digital channel, and we process the case on the ground in Togo. You then receive your original document by secure express mail or through a mandated relative.",
  },
  {
    q: "What are the average processing times?",
    a: "Timelines vary by procedure: from 72 hours for some civil status records to 2-4 weeks for a passport or a full company formation. A precise schedule is provided once we review your request, and you are informed at every step.",
  },
  {
    q: "How much does DOC TOGO support cost?",
    a: "Every request receives a clear, detailed quote before any commitment: official administrative fees + support fees. No hidden costs, no payment before you approve the quote.",
  },
  {
    q: "Are my data and documents safe?",
    a: "Yes. Your documents are transmitted through a secure form and stored encrypted. They are used strictly for your procedure and never shared with third parties.",
  },
  {
    q: "Which payment methods are accepted?",
    a: "Mobile Money (T-Money, Moov Money), domestic and international bank transfers, and bank cards (Visa / Mastercard). Exact details are shown on your quote.",
  },
  {
    q: "Can I track the progress of my case?",
    a: "Absolutely. Every request receives a unique reference. You are notified at each key milestone by email or WhatsApp, and you can contact us anytime for a status update — or use our online tracking page.",
  },
  {
    q: "Is DOC TOGO a public administration?",
    a: "No. DOC TOGO is a private assistance and administrative support platform. We are not the Togolese administration and do not replace it: we prepare, file and track your applications with the competent authorities, legally, saving you time and preventing errors.",
  },
  {
    q: "Can I create a company in Togo without living there?",
    a: "Yes. We regularly support diaspora entrepreneurs and foreign investors: choosing the legal structure, drafting articles of association, CFE registration, obtaining the RCCM and NIF — all of which can be managed remotely.",
  },
  {
    q: "Which documents do I need to get started?",
    a: "It depends on your procedure. Describe your need: within 24h you will receive the exact, up-to-date list of required documents and accepted formats (scans, legible photos, originals if needed).",
  },
  {
    q: "Do you also work with established companies?",
    a: "Yes. We assist SMEs and organisations with their ongoing formalities: statutory changes, renewals, administrative compliance, file follow-up with government agencies and support for executives based abroad.",
  },
];

export const MARQUEE_EN = [
  "Passport", "National ID", "Company formation", "Police clearance", "Visa & residence",
  "Travel pass", "Civil status records", "RCCM registration", "Driving licence", "Residence permit",
];

export const WHY_POINTS_EN = [
  {
    title: "A single point of contact",
    desc: "No more queues and back-and-forth. A dedicated advisor manages your case from A to Z.",
  },
  {
    title: "Built for the diaspora",
    desc: "90% of procedures can be done remotely. You track everything from your phone, wherever you live.",
  },
  {
    title: "Zero bad surprises",
    desc: "Quote before commitment, announced and respected timelines, official documents verified before delivery.",
  },
];

export const PROFILS_EN = [
  "Togolese diaspora",
  "Resident in Togo",
  "Foreign national wishing to come to Togo",
  "Entrepreneur / Investor",
  "Company / Organisation",
];

export const FORM_CATEGORIES_EN = [
  "Administrative documents",
  "Company formation",
  "Diaspora services",
  "Foreign nationals services",
  "Business services",
  "Other need",
];

export const FORM_SERVICES_EN = {
  "Documents administratifs": [
    "Togolese passport",
    "National ID card (CNI)",
    "Police clearance certificate",
    "Birth certificates & civil status records",
    "Driving licence",
    "Travel pass (sauf-conduit)",
    "Visa & residence formalities",
    "Other administrative procedure",
  ],
  "Création d'entreprise": [
    "Legal structure guidance",
    "Application file preparation",
    "Incorporation formalities (CFE)",
    "NIF & RCCM registration",
    "Constitutive documents",
    "Post-incorporation formalities",
    "Entrepreneur / investor support",
  ],
  "Services diaspora": [
    "Remote procedure",
    "Administrative representation in Togo",
    "Real estate project & land title check",
    "Legalisation & apostille",
    "Other diaspora request",
  ],
  "Services étrangers": [
    "Entry visa & extension",
    "Residence permit",
    "Settling in Togo",
    "Investment & subsidiary setup",
    "Other request",
  ],
  "Services entreprises": [
    "Administrative assistance",
    "File preparation & follow-up",
    "Formalities with government agencies",
    "Support for executives abroad",
  ],
  "Autre besoin": ["I'm not sure yet — I'd like advice"],
};
